import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from 'lodash';
import { Grid } from "@material-ui/core";
import TypeAheadDropdown from "../Components/TypeAheadDropdown";
import GridTextArea from "../Components/GridTextArea";
import SectionTitle from '../Components/SectionTitle';
import { getConfigItemByParentId } from "store/state/configItems";
import loanStatuses from 'constants/loanStatuses';
import { PASS_REASON } from "constants/configItemParents";
import { setConfigItemListState } from "../util";

class LenderPassed extends React.Component {
  state = {
    passReasons: []
  };

  componentDidMount() {
    this.props.getConfigItemByParentId({
      id: PASS_REASON
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.configItems.configItemByParent && _.isEmpty(this.state.passReasons)) {
      setConfigItemListState(PASS_REASON, "passReasons", this);
    }
  }

  render() {
    const {
      loan,
      handleChange,
      handleTextChange,
      isInitialized,
      isEditing
    } = this.props;

    return (
      <Fragment>
        <Grid item xs={12}>
            <SectionTitle id="passed-quote">Passed Quote</SectionTitle>
        </Grid>
        <Grid container item xs={12}>
          <TypeAheadDropdown
            name="passReasonId"
            label="Pass Reason"
            placeholder="Select a Pass Reason"
            options={this.state.passReasons}
            value={loan.passReasonId}
            handleChange={data => handleChange("passReasonId", data)}
            isEditing={isEditing}
            shouldShow={isInitialized}            
          />
        </Grid>
        <Grid container item xs={12}>
          <GridTextArea
              name="passComment"
              label="Pass Comment"
              value={loan.passComment}
              multiline={true}
              onChange={handleTextChange}
              isEditing={isEditing}
              shouldShow={isInitialized}
            />
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loading, configItems } = state;
  return {
    loading,
    configItems
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemByParentId
    }
  )
)(LenderPassed);
